import { MockDataType } from 'src/Types/type';
import { USER_PROFILE_PATH } from 'Const/Constant';
export const messageJson: MockDataType[] = [
  {
    userId: '926931d2',
    userName: '사람1',
    profileImage: USER_PROFILE_PATH.ID_926931d2,
    content: '안녕하세요',
    date: '2022-02-09 23:22:32',
    isDel: false,
  },
  {
    userId: 'c58e261b',
    userName: '사람2',
    profileImage: USER_PROFILE_PATH.ID_c58e261b,
    content: '네 안녕하세요',
    date: '2022-02-10 09:22:32',
    isDel: false,
  },
  {
    userId: '65bd3353',
    userName: '사람3',
    profileImage: USER_PROFILE_PATH.ID_65bd3353,
    content: '반갑습니다!',
    date: '2022-02-10 10:04:32',
    isDel: false,
  },
  {
    userId: '926931d2',
    userName: '사람1',
    profileImage: USER_PROFILE_PATH.ID_926931d2,
    content: '다들 시간 괜찮으신가요??',
    date: '2022-02-10 12:04:32',
    isDel: false,
  },
  {
    userId: 'c58e261b',
    userName: '사람2',
    profileImage: USER_PROFILE_PATH.ID_c58e261b,
    content: '전 언제든 괜찮죠!!!',
    date: '2022-02-10 12:04:32',
    isDel: false,
  },
];
